var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.441 8.852a1.194 1.194 0 0 0 0-1.51L8.357.25a.66.66 0 0 0-1.033 0L1.24 7.342a1.195 1.195 0 0 0 0 1.51c.359.418.937.418 1.296 0l5.308-6.178 5.309 6.187c.351.41.937.41 1.288-.009"
  })));
};
export default SvgChevronUp;